import {ReactNode} from "react";
import {BadgeVariant} from "@interstate/components/Badge";
import {
  ArrowPathIcon,
  ArrowTopRightOnSquareIcon,
  BuildingOfficeIcon,
  CheckCircleIcon,
  InformationCircleIcon,
  NoSymbolIcon,
  XCircleIcon
} from "@interstate/components/Icons";
import {InterstateToken} from "../../../../../lib/interstate";
import {BadgeMetadata} from "../../../../../badges";
import {SpinnerIcon} from "../../../../../icons";
import {CreateResult} from "../../view-model";

const variantForResult = (result: CreateResult): BadgeVariant => {
  switch (result.status) {
    case "queued":
      return "transparent";
    case "in-progress":
      return "info";
    case "created":
      return "success";
    case "operational":
      return "transparent";
    case "skipped":
      return "info";
    case "failed":
      return "error";
  }
};

const startIconForResult = (
  token: InterstateToken,
  result: CreateResult
): ReactNode | undefined => {
  switch (result.status) {
    case "queued":
      return <ArrowPathIcon />;
    case "in-progress":
      return <SpinnerIcon />;
    case "created":
      return <BuildingOfficeIcon />;
    case "operational":
      return (
        <CheckCircleIcon color={token("sem.color.on-surface.success.muted")} />
      );
    case "skipped":
      return result.message ? <InformationCircleIcon /> : <NoSymbolIcon />;
    case "failed":
      return result.message ? <InformationCircleIcon /> : <XCircleIcon />;
  }
};

const endIconForResult = (result: CreateResult): ReactNode | undefined => {
  switch (result.status) {
    case "created":
      return <ArrowTopRightOnSquareIcon />;
  }
};

export const resultBadgeMetadata = (
  token: InterstateToken,
  result: CreateResult
): BadgeMetadata => {
  return {
    labelKey: `create-organization.result-states.${result.status}`,
    variant: variantForResult(result),
    startIcon: startIconForResult(token, result),
    endIcon: endIconForResult(result)
  };
};
